import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CaseDraft } from '../../../interfaces/CaseDraft';
import { RootState } from '../../setupStore';

export interface CaseDraftState {
  value: CaseDraft | null;
}

const initialState: CaseDraftState = {
  value: null,
};

export const CaseDraftSlice = createSlice({
  name: 'caseDraft',
  initialState,
  reducers: {
    setCaseDraft: (state, action: PayloadAction<CaseDraft | null>) => {
      state.value = action.payload;
    },
    clearCaseDraft: (state) => {
      state.value = null;
    },
  },
});

export const { setCaseDraft, clearCaseDraft } = CaseDraftSlice.actions;

export const selectDraft = (state: RootState) => state.caseDraft.value;

export default CaseDraftSlice.reducer;
